<template>
  <el-container class="container">
    <el-header>
      <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" class="collapse-btn" @click="toggleCollapse"></i>
      <div class="head_left">
        <span>集中交易系统后台管理</span>
      </div>
      <div class="head_right">
        <span>你好，{{ userName }}</span>
        <el-link @click="loginOut" class="exit" type="warning">退出</el-link>
      </div>
    </el-header>

    <el-container class="main_container">
      <el-aside :width="isCollapse ? '64px' : '200px'" class="side-menu" :class="{ collapsed: isCollapse }">
        <el-menu :default-active="activeMenuIndex" :collapse="isCollapse" :collapse-transition="false"
          class="menu home-menu">
          <el-menu-item
            v-for="menu in mhomeMenus"
            :key="menu.index"
            :index="menu.index"
            class="my-el-menu"
            @click="$router.push(menu.path)"
          >
            <i :class="menu.icon" v-if="menu.icon"></i>
            <span slot="title" class="collapse-submenu-text">{{ menu.name }}</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <div class="div_router">
          <transition name="move" mode="out-in">
            <router-view :key="key"></router-view>
          </transition>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import utils from "../lib/utils";

export default {
  name: "managerHome",
  data() {
    return {
      msg: "Welcome to homeeeeeeeeeeeeeeee",
      userName: "",
      isCollapse: false
    };
  },
  computed: {
    key() {
      return this.$route.path;
    },
    activeMenuIndex() {
      const currentPath = this.$route.path;
      const menu = this.mhomeMenus.find(m => m.path === currentPath);
      return menu ? menu.index : '';
    },
    mhomeMenus() {
      const mhomeRoute = this.$router.options.routes.find(r => r.path === '/mHome');
      if (!mhomeRoute || !mhomeRoute.children) return [];
      
      return mhomeRoute.children
        .filter(route => {
          if (!route.meta || !route.meta.roles || route.meta.roles.length === 0) {
            return true;
          }
          return route.meta.roles.includes('admin');
        })
        .map((route, index) => ({
          index: `0-${index + 1}`,
          path: route.path,
          name: route.meta && route.meta.title ? route.meta.title : route.name,
          icon: route.meta && route.meta.icon ? route.meta.icon : ''
        }));
    }
  },
  methods: {
    loginOut() {
      this.$confirm("确认退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          utils.delCookie("tamc_admin_token");
          localStorage.removeItem("admin-uid");
          this.$router.push("/adminLogin");
        })
        .catch(() => {});
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    }
  },
  created() {
    this.userName = localStorage.getItem("admin-uid");
  }
};
</script>

<style scoped>
@import "../assets/css/managerHome.scss";
</style>

<style>
@import "../assets/css/index.scss";

/* 折叠菜单 tooltip 弹出框样式 — 必须放在非 scoped 中 */
.el-tooltip__popper {
    max-width: 80px !important;
    min-width: 40px !important;
    width: auto !important;
    padding: 5px 8px !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3) !important;
}
.el-tooltip__popper.is-dark {
    background-color: #303133 !important;
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: #ffffff !important;
}
.el-tooltip__popper.is-dark .el-tooltip__inner {
    color: #ffffff !important;
    background-color: #303133 !important;
    padding: 0 !important;
    max-width: 80px !important;
    line-height: 1.4 !important;
}
.el-tooltip__popper.is-dark[x-placement^="right"] .popper__arrow {
    border-right-color: #303133 !important;
}
.el-tooltip__popper.is-dark[x-placement^="right"] .popper__arrow::after {
    border-right-color: #303133 !important;
    margin-left: 1px;
}
.el-tooltip__popper.is-dark[x-placement^="top"] .popper__arrow {
    border-top-color: #303133 !important;
}
.el-tooltip__popper.is-dark[x-placement^="top"] .popper__arrow::after {
    border-top-color: #303133 !important;
    margin-top: 1px;
}
.el-tooltip__popper.is-dark[x-placement^="bottom"] .popper__arrow {
    border-bottom-color: #303133 !important;
}
.el-tooltip__popper.is-dark[x-placement^="bottom"] .popper__arrow::after {
    border-bottom-color: #303133 !important;
    margin-bottom: 1px;
}
.el-tooltip__popper.is-dark[x-placement^="left"] .popper__arrow {
    border-left-color: #303133 !important;
}
.el-tooltip__popper.is-dark[x-placement^="left"] .popper__arrow::after {
    border-left-color: #303133 !important;
    margin-right: 1px;
}
</style>
